import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EmployeeService } from '../employee.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-empdelete-dialog',
  templateUrl: './empdelete-dialog.component.html',
  styleUrls: ['./empdelete-dialog.component.scss']
})
export class EmpdeleteDialogComponent implements OnInit{
  isChecked = false;
  show = true;
  accountdeletedetails: any;

  constructor(private dialogRef: MatDialogRef<EmpdeleteDialogComponent>, private loginService: EmployeeService, private spinner: NgxSpinnerService){}
 
ngOnInit(): void {

}

onCheckboxChange() {
  console.log(this.isChecked);
}

dialogclose() {
  this.dialogRef.close();
}

success() {
  this.spinner.show();
  this.loginService.accountDelete(localStorage.getItem('token')).subscribe((res) => {
    console.log('res', res);
    this.spinner.hide();
    this.accountdeletedetails = res;
    this.show = !this.show;
  });
}

submit() {
  this.dialogRef.close();
}

}
